export function SentencesList(props: {
  data: unknown[] | unknown;
  showNa?: boolean;
}) {
  if (props.data === undefined)
    return props.showNa ? (
      <div
        style={{
          textAlign: "right",
          height: 0,
          top: -26,
          position: "relative",
        }}
      >
        N/A
      </div>
    ) : null;
  let sentences =
    typeof props.data === "string"
      ? props.data
          .split(". ")
          .filter(Boolean)
          .map((q) => (q.endsWith(".") ? q : `${q}.`))
      : props.data;
  sentences = Array.isArray(sentences) ? sentences : [sentences];
  return (
    <ul
      style={{
        margin: 0,
        listStyleType: (sentences as string[]).length > 1 ? undefined : "none",
        padding: (sentences as string[]).length > 1 ? "0 0 0 16px" : 0,
      }}
    >
      {(sentences as string[]).map((text, i) => (
        <li
          key={`${text}`}
          style={{
            paddingTop: i === 0 ? undefined : 8,
            marginTop: i === 0 ? undefined : 8,
          }}
        >
          {text as any}
        </li>
      ))}
    </ul>
  );
}
